import {Fragment, useState} from "react";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import Modal from "react-bootstrap/Modal";
import DynamicFields from "../dynamicFields/DynamicFields";
import {InputType, Loading} from "../../utils/helpers/constants";
import ProfileService from "../../utils/services/profile.service";

const EditVehicleOwnerProfileModal = ({onchange, props, dynamicFields, onSuccessResponse}) => {
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);
  

  const handleClose = () => {
    setShow(false);
    onchange();
  };

  const useFormHook = useForm({
    defaultValues: (props && props['dynamic_fields']) ? props['dynamic_fields'] : {},
    mode: "all",
    reValidateMode: "onChange",
    criteriaMode: "firstError",
  });

  const handleUpdateVehicleOwnerProfile = async () => {
    setLoading(true);
    const payload = { dynamic_fields: { ...props['dynamic_fields'], ...useFormHook.getValues()}};
    const {data: responseData} = await ProfileService.updateVehicleOwnerProfile(props.id, payload);
    if (responseData.status !== Loading.SUCCESS) {
      const message = (responseData && responseData.message) ? responseData.message : "You cannot update your vehicle owner information at the moment. Please try again later.";
      toast.error(message);
    }
    else {
      toast.success(responseData.message);
      onSuccessResponse();
      handleClose();
    }
    setLoading(false);
  }

  const renderDynamicFields = dynamicFields.map((formControl, index) => {
    return (
      <Fragment key={index}>
        {(formControl.type !== InputType.FILE && (formControl.key === 'nin' || formControl.key === 'cac_number' || formControl.key === 'house_address')) &&
          <DynamicFields divClass="col-lg-6 form-group mb-4" inputClass="form-control"
            formControl={formControl} formHook={useFormHook} initialValue={props['dynamic_fields']} />
        }
      </Fragment>
    )
  });

  
  return (
    <>
      <Modal show={show} backdrop="static" keyboard={false} size="lg" centered scrollable>
        <Modal.Body>
          <span id="close-modal-btn1" onClick={handleClose} className="close-modal mt-2 fs-1 text-danger">&times;
          </span>
          <div className="proceed">
            <div className="mt-2 mb-5">
              <h5>Edit Vehicle Owner Information</h5>
            </div>
            <div className="mt-4">
              <div className="row">
                {renderDynamicFields}
              </div>
            </div>
            <div className="d-flex justify-content-end mt-5">
              <button onClick={useFormHook.handleSubmit(handleUpdateVehicleOwnerProfile)} className="btn main-btn w-auto">
                Update Vehicle Owner Profile
                {loading && <>&nbsp;<i className="zmdi zmdi-spinner mg-l-1 ms-2 zmdi-hc-spin"/></>}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default EditVehicleOwnerProfileModal;